import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import { LoadingEllipsis } from '../common/LoadingEllipsis.js';

export const ResourceSelectors = createReactClass({
    propTypes: {
        onSelect: PropTypes.func.isRequired,
        handleAutoResourceSelectionChange: PropTypes.func.isRequired,
        resourceIds: PropTypes.object,
        projectId: PropTypes.number,
        loggedInUser: PropTypes.bool,
        resourceError: PropTypes.string,
        showResourceIssueField: PropTypes.bool,
        clearResourceIdsFormField: PropTypes.func.isRequired,
    },

    getInitialState() {
        return {
            resourceCarts: [],
            loadingResources: false,
        };
    },

    componentDidMount() {
        if (this.props.resourceIds === null) {
            this.props.clearResourceIdsFormField();
        }
        if (this.props.loggedInUser && this.props.projectId) {
            this.setupResources();
        }
    },

    // get resources if selected project changed
    componentDidUpdate(prevProps) {
        if (this.props.loggedInUser && !this.state.loadingResources) {
            if (!(this.props.loggedInUser === prevProps.loggedInUser && this.props.projectId === prevProps.projectId)) {
                this.props.clearResourceIdsFormField();
                this.setupResources();
            }
        }
    },

    setupResources() {
        if (this.props.projectId) {
            this.setState({
                loadingResources: true,
            });
            var resourcesPromise = this.getResourcesForProposal(this.props.projectId);

            resourcesPromise.then((result) => {
                this.setState({
                    resourceCarts: result,
                    loadingResources: false,
                });
            });
        } else {
            this.setState({
                resourceCarts: [],
            });
        }
    },

    getResourcesForProposal(proposalId) {
        return $.ajax({
            url: '/common/ariba_resources.html',
            data: { proposalId: proposalId },
            dataType: 'json',
        });
    },

    renderResources(resourceCarts) {
        this.resourceIndex = 0;
        if (this.state.loadingResources) {
            return (
                <div className="input-holder">
                    <LoadingEllipsis />
                </div>
            );
        } else {
            if (resourceCarts.length > 0) {
                return (
                    <div>
                        <div className="friendly-reminder" id="vendor-email-message">
                            <p>Your email will go directly to the vendors of the items you choose and they will respond directly to you.</p>
                        </div>
                        <div id="resourceCheckboxes" className={this.props.resourceError ? 'hasError' : ''}>
                            {this.renderResourcesByPurchaseOrder(resourceCarts)}
                        </div>
                        {this.props.resourceError ? (<div className="error-text">{this.props.resourceError}</div>) : null}
                    </div>
                );
            } else {
                if (this.props.projectId) {
                    return (
                        <div className="friendly-reminder" id="no-resources-message">
                            <p>Contact our team for an update on your project.</p>
                        </div>
                    );
                }
            }
        }
    },

    // if we aren't showing issue field, include "select all" po checkboxes
    renderResourcesByPurchaseOrder(resourceCarts) {
        return resourceCarts.map((purchaseOrder, index) => {
            if (this.props.showResourceIssueField) {
                return (
                    <div key={index}>
                        <span>{purchaseOrder.vendorName}{purchaseOrder.isReplacement === true ? ' (Replacement)' : ''}</span>
                        {this.renderResourceCheckboxes(purchaseOrder.resources, purchaseOrder.cartId)}
                    </div>
                );
            } else {
                return (
                    <div key={index}>
                        <label>
                            <input
                                type="checkbox"
                                id={purchaseOrder.cartId}
                                onChange={this.selectPO}
                                value=""
                            />
                            <span>Select all {purchaseOrder.vendorName}{purchaseOrder.isReplacement === true ? ' (Replacement) ' : ' '}items</span>
                        </label>
                        {this.renderResourceCheckboxes(purchaseOrder.resources, purchaseOrder.cartId)}
                    </div>
                );
            }
        });
    },

    renderResourceCheckboxes(resources, cartId) {
        return resources.map((resource, index) => {
            var resourceIndex = this.resourceIndex++;
            return (
                <div key={index}>
                    <label className="resource-label">
                        <input
                            type="checkbox"
                            className={'cartId' + cartId}
                            id={'resourceIds[' + resourceIndex + ']'}
                            checked={!!this.props.resourceIds[resourceIndex]}
                            onChange={this.props.onSelect}
                            value=""
                        />
                        <span dangerouslySetInnerHTML={{ __html: resource.details }} />
                    </label>
                    {this.renderQuantityField(resource, resourceIndex)}
                    {this.renderResourceFormField(resource, resourceIndex)}
                    {this.props.showResourceIssueField && this.renderIssueField(resource, resourceIndex)}
                </div>
            );
        });
    },

    // hidden input that is returned with checked resources so that the chosen resources are correctly sent with the form
    renderResourceFormField(resource, index) {
        if (this.props.resourceIds[index]) {
            return (<div className="input-holder">
                <input type="hidden" name={'resourceIds[' + index + ']'} value={resource.id} />
            </div>
            );
        }
    },

    handleQuantityChange(event) {
        var newState = {};
        newState[event.target.name] = event.target.value;
        this.setState(newState);
    },

    // auto select/unselect all resources under the chosen po
    selectPO(event) {
        const cartId = event.target.id;
        const resourceElements = document.getElementsByClassName('cartId' + cartId);

        for (let i = 0; i < resourceElements.length; i++) {
            const resource = resourceElements[i];

            if (resource.checked !== event.target.checked) {
                this.props.handleAutoResourceSelectionChange(resource.id, event.target.checked);
            }
        }
    },

    renderQuantityField(resource, index) {
        if (this.props.resourceIds[index]) {
            var quantityState = this.state['quantity_' + resource.id];
            return (
                <div className="quantity">
                    <label>Quantity&nbsp;
                        <input type="number" id={'quantity_' + resource.id} name={'quantity_' + resource.id} value={quantityState || quantityState === '' ? quantityState : resource.quantity} onChange={this.handleQuantityChange}></input>
							of {resource.quantity}
                    </label>
                </div>
            );
        }
    },

    renderIssueField(resource, index) {
        if (this.props.resourceIds[index]) {
            return (
                <div className="issue">
                    <label>Issue</label>
                    <textarea rows="4" id={'issue_' + resource.id} name={'issue_' + resource.id}></textarea>
                </div>
            );
        }
    },

    render() {
        return (<div className="input-holder">
            <div id="resourcesDiv">
                {this.renderResources(this.state.resourceCarts)}
            </div>
        </div>
        );
    },
});
